import { APIMethod, fetchData } from "@client";

export async function addProjectObserverQuery(uuid, user) {
  const data = { uuid, user, role: "observer" };
  return await fetchData("/project/invite", APIMethod.PUT, { data });
}
